const currentDate = new Date()
const month = (currentDate.getMonth() + 1).toString()
const year = currentDate.getFullYear().toString().substring(2, 4)


export const cpfMask = value => {
  if (!value) return;
  return value
    .replace(/\D/g, "")
    .replace(/(\d{3})(\d)/, "$1.$2")
    .replace(/(\d{3})(\d)/, "$1.$2")
    .replace(/(\d{3})(\d{1,2})/, "$1-$2")
    .replace(/(-\d{2})\d+?$/, "$1");
};

export const cardCredit = value => {
  if (!value) return;
  return value
    .replace(/\D/g, "")
    .replace(/(\d{4})(\d)/, "$1 $2")
    .replace(/(\d{4})(\d)/, "$1 $2")
    .replace(/(\d{4})(\d)/, "$1 $2")
    .replace(/(-\d{4})(\d)/, "$1").substring(0, 19);
};

export const validCard = value => {
  if (!value) return;
  const val = value
    .replace(/\D/g, "")
    .replace(/(\d{1})(\d)/, "$1$2/")
    .replace(/(\d{1})(\d)/, "$1$2").substring(0, 5);
  if (value.length) {
    if (value[0] !== "0" && value[0] !== "1") return ""
    if (value.length > 1 && ((value[0] === "0" && value[1] === "0")
      || (value[0] === "1" && value[1] > 2))) {
      return value.substring(0, 1)
    }
    if (value.length > 3 && (value[3] < year[0])) return value.substring(0, 3)
    if (value.length === 5 && `${value[3]}${value[4]}` <= year  && (`${value[0]}${value[1]}` < month)) {
      return value.substring(0, 3)
    }
  }
  return val
};

export const validCodeCard = value => {
  if (!value) return;
  return value
    .replace(/\D/g, "")
    .replace(/(\d{3})(\d)/, "$1/").substring(0, 3);
};

export const heightMask = value => {
  if (!value) return;
  return value
    .replace(/\D/g, "")
    .replace(/(\d{1})(\d)/, "$1.$2").substring(0, 4);
};

export const weightMask = value => {
  if (!value) return;
  return value
    .replace(/\D/g, "")
    .replace(/(\d{3})/, "$1").substring(0, 3);
};

export const phoneMask = value => {
  if (!value) return;
  return value
    .replace(/\D/g, "")
    .replace(/(\d{2})(\d)/, "($1) $2")
    .replace(/(\d{5})(\d{1,2})/, "$1-$2")
    .replace(/(-\d{4})\d+?$/, "$1").substring(0, 15);
};

export const zipCode = value => {
  if (!value) return;

  return value.replace(/\D/g, "").replace(/(\d{5})(\d{3})/, "$1-$2").substring(0, 9);
};
